<template>
    <cBody>
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 状态 -->
                    <span class="status-text">状态</span>
					<Select @on-change="getAlgorithmnConfig" v-model="tableParams.status" style="width:200px">
                        <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.name }}</Option>
                    </Select>
                </div>
            </div>
        </header>
        <section slot="section" class="c-body-section">
            <table class="c-body-table">
				<!-- 表头 -->
				<thead class="table-thead">
					<tr class="table-tr">
						<td 
                            class="table-td-primary"
                            :class="{'table-td-long':index==1}"
                            v-for="(item,index) in tableList" 
                            :key="item.title"
                        >
                            {{item.title}}
                        </td>
					</tr>
				</thead>
				<!-- 表头 -->
				<tbody class="table-tbody">
            		<tr v-for="(item,index) in originData" class="table-tr" :key="index">
						<td class="table-td-primary" width="15%">{{item.id}}</td>
						<td class="table-td-primary table-td-long" width="20%"><p class="showregular" :title="item.name">{{item.name}}</p></td>
						<td class="table-td-primary" width="15%">{{item.uploadTime}}</td>
						<td class="table-td-primary" width="20%">
                            <span :title="item.description">{{item.description.length>18?item.description.substr(0,18)+'...':item.description?item.description:'\\'}}</span>
                            <Poptip @on-popper-show="editValue=item.description" title="修改备注" trigger="click" class="cPop-box">
                                <div slot="content">
                                    <Input v-model="editValue" style="width: 2rem;" placeholder="请输入备注" :maxlength="35"/>
                                    <div class="footer-wrapper">
                                        <Button size="small" @click="$root.$el.click()">取消</Button>
                                        <Button size="small" type="primary" @click="onConfirm('description',item)">确定</Button>
                                    </div>
                                </div>
                                <Icon class="edit-btn" type="compose"></Icon>
                            </Poptip>
                        </td>
						<td class="table-td-primary" width="15%">
                            <span>{{item.weight?item.weight:'\\'}}</span>
                            <Poptip @on-popper-show="editValue=item.weight" title="修改流量分配" trigger="click" class="cPop-box">
                                <div slot="content">
                                    <Input :maxlength="1" v-model="editValue" placeholder="请输入流量分配" style="width: 2rem;"/>
                                    <div class="footer-wrapper">
                                        <Button size="small" @click="$root.$el.click()">取消</Button>
                                        <Button size="small" type="primary" @click="onConfirm('weight',item)">确定</Button>
                                    </div>
                                </div>
                                <Icon class="edit-btn" type="compose"></Icon>
                            </Poptip>
                        </td>
						<td class="table-td-primary" width="15%">
                            <i-switch v-model="item.status" :true-value="1" :false-value="0" @on-change="changeItem('status',item)">
                                <span slot="open">开</span>
                                <span slot="close">关</span>
                            </i-switch>
                        </td>
					</tr>
				</tbody>
            </table>
        </section>
    </cBody>
</template>

<script>
import cBody from '@/components/commons/cBody.vue';
import cPage from '@/components/commons/cPage.vue';
export default {
    name: 'AlgorithmnConfig',
    components: { cBody, cPage },
    data() {
        return {
            editValue: '',
            //表格参数
            tableParams: {
                status: -1,
                // page: 1,
                // pageSize: 10,
            },
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 0,
            },
            //状态列表
            statusList: [{ name: '全部', value: -1 }, { name: '开', value: 1 }, { name: '关', value: 0 }],
            //表头
            tableList: [{ title: '算法ID' }, { title: '算法名称' }, { title: '上线时间' }, { title: '备注' }, { title: '流量分配比例' }, { title: '状态' }],
            originData: [],
        };
    },
    mounted() {
        this.getAlgorithmnConfig();
    },
    methods: {
        /**
         * @desc 修改算法item的属性
         * @param {String} type 修改的属性
         * @param {Item} item 修改的对象
         */
        async changeItem(type, item) {
            let editValue = this.editValue;
            if (type == 'status') editValue = item.status;
            if (type == 'weight' && !editValue) editValue = 0;
            const params = {
                id: item.id,
                [type]: editValue,
            };
            const res = await this.$axios.get(this.$port.algorithmn.update, { params });
            this.$axios.commonCallback(res, '修改成功');
            this.getAlgorithmnConfig();
        },
        /**
         * @desc 获取列表
         */
        async getAlgorithmnConfig() {
            const params = { status: this.tableParams.status == -1 ? '' : this.tableParams.status };
            const res = await this.$axios.get(this.$port.algorithmn.list, { params });
            this.originData = res.data;
        },
        /**
         * @desc 确认
         * @param {String} type 修改的属性
         */
        onConfirm(type, item) {
            this.$root.$el.click();
            this.changeItem(type, item);
        },
    },
};
</script>

<style lang="scss">
.status-text {
    font-size: 0.14rem;
    margin-right: 0.2rem;
}
.edit-btn {
    cursor: pointer;
    position: relative;
    top: 0.01rem;
    margin-left: 0.05rem;
    font-size: 0.18rem;
    display: inline-block;
}
.rebase-text {
    position: relative;
    .edit-btn {
        position: absolute;
        right: -0.14rem;
        top: -0.15rem;
    }
}
.cPop-box {
    .ivu-poptip-title {
        text-align: left;
    }
    .ivu-poptip-title:after {
        height: 0;
    }
    .footer-wrapper {
        text-align: right;
        padding: 0.1rem 0 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Algorithm/Config.vue